"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportAgentAdd = reportAgentAdd;
exports.reportAgentDelete = reportAgentDelete;
exports.reportAgentEdit = reportAgentEdit;
exports.reportAgentFrozen = reportAgentFrozen;
require("core-js/modules/es6.function.name");
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】代理商管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：添加/编辑/删除/冻结代理等，由页面在业务成功后调用
 */

/**
 * 添加代理埋点上报
 * @param {Object} agentInfo - 代理信息
 */
function reportAgentAdd(agentInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '添加代理',
    content: "\u65B0\u589E\u4EE3\u7406\u300C".concat(agentInfo.name, "\u300D\uFF0C\u624B\u673A\u53F7 ").concat(agentInfo.phone, "\uFF0C\u5F00\u901A\u7C7B\u578B role_id=").concat(agentInfo.role_id),
    operation_id: 'pc_agent_add_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_agent_add_1');
}

/**
 * 编辑代理埋点上报
 * @param {number} agentId - 代理ID
 * @param {Object} agentInfo - 代理信息
 */
function reportAgentEdit(agentId, agentInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '编辑代理',
    content: "\u7F16\u8F91\u4EE3\u7406\u300C".concat(agentInfo.name, "\u300D(ID:").concat(agentId, ")\uFF0C\u624B\u673A\u53F7 ").concat(agentInfo.phone),
    operation_id: 'pc_agent_edit_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_agent_edit_1');
}

/**
 * 删除代理埋点上报
 * @param {number} agentId - 代理ID
 * @param {string} agentName - 代理姓名
 */
function reportAgentDelete(agentId, agentName) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '删除代理',
    content: "\u5220\u9664\u4EE3\u7406\u300C".concat(agentName, "\u300D(ID:").concat(agentId, ")"),
    operation_id: 'pc_agent_delete_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_agent_delete_1');
}

/**
 * 冻结/解冻代理埋点上报
 * @param {number} agentId - 代理ID
 * @param {string} agentName - 代理姓名
 * @param {number} status - 状态 1:冻结 0:解冻
 */
function reportAgentFrozen(agentId, agentName, status) {
  var action = status === 1 ? '冻结' : '解冻';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: "".concat(action, "\u4EE3\u7406"),
    content: "".concat(action, "\u4EE3\u7406\u300C").concat(agentName, "\u300D(ID:").concat(agentId, ")"),
    operation_id: 'pc_agent_frozen_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_agent_frozen_1');
}